exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.email[data-v-10c57684] { padding-right: 10px;\n}\n", ""]);

// exports
